import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { t } from 'i18next';
const EditNotes = ({ control, label, placeholder, 'data-testid': testId, }) => (_jsx(Controller, { name: 'notes', control: control, render: ({ field, fieldState }) => {
        const charsRemaining = 5000 - (field.value?.length ?? 0);
        const showRemaining = charsRemaining <= 500;
        return (_jsx(TextField, { ...field, slotProps: {
                inputLabel: { className: 'pb-1' },
                htmlInput: { maxLength: 5000 },
            }, label: label, fullWidth: true, multiline: true, rows: 4, placeholder: placeholder, "data-testid": testId, "data-label": "form-input", size: "small", error: !!fieldState.error, helperText: fieldState.error?.message ??
                (showRemaining
                    ? t('common.notesCharactersRemaining', { count: charsRemaining })
                    : '') }));
    } }));
export default EditNotes;
